import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Box } from '~/eds/src/components/Box/Box';
import { HashLink } from '~/eds/src/components/Link/subcomponents/HashLink';

import { MAIN_CONTENT_ID } from './constants';

export const SkipToMainLink = () => {
  return (
    <Box styles={componentStyles.hidden}>
      <HashLink disableScroll hash={MAIN_CONTENT_ID}>
        <FormattedMessage
          id="SkipToMainLink.skipToMainContent"
          defaultMessage="Skip to main content"
          description="Link for skipping to main content"
        />
      </HashLink>
    </Box>
  );
};

const componentStyles = {
  hidden: {
    '> a': {
      backgroundColor: 'background',
      left: '-9999px',
      opacity: 0,
      padding: '12px',
      position: 'absolute',
      zIndex: 999,
    },
    '> a:focus': {
      left: 0,
      opacity: 1,
    },
  },
};
